/** Shared by the Getting Started cards and the setup checklist's app-download modal. */
export const gettingStartedLinks = {
  learnMore: "https://coachnow.io/video",
  playStoreLink:
    "https://play.google.com/store/apps/details?id=com.edufii&referrer=utm_source%3Dwebapp%26utm_medium%3Donboarding%26utm_campaign%3Dv1",
  appStoreLink:
    "https://apps.apple.com/app/apple-store/id596598472?pt=117236&ct=web-onboarding&mt=8",
  book_a_demo_link: "https://coachnow.io/demo?utm_source=welcomepage",
};
